import { ChangeDetectorRef, Component, NgZone, OnInit, OnDestroy, Injector } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, mergeMap, debounceTime, map } from 'rxjs/operators';
import {
  LoggedComponent,
  LoggerService,
  RankSortingTypeEnum,
  SeriesProItem,
  SeriesProLocator,
  ViewDataInterface,
  ViewDataService,
  WCupRankingLocator
} from 'world-archery-lib';
import { FiltersSeriesEliteRankingService } from '../filters-series-elite-ranking.service';
import { RankingItem } from 'world-archery-lib';
import { EliteRankingIndoorStore } from '../../../common-page-components/stores/entities-store/elite-ranking-indoor-store';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import {animationsTable} from '../../../common-page-components/wa-table/wa-table.component';

@Component({
  selector: 'app-elite-ranking-list',
  templateUrl: './elite-ranking-list.component.html',
  styleUrls: ['./elite-ranking-list.component.scss'],
  animations: animationsTable
})
export class EliteRankingListComponent extends TableAbstractComponent
  implements OnInit, OnDestroy {
  headers = [
    { name: 'Ranking', isSortable: true, sortProperty: 'RANKING' },
    { name: 'Name', isSortable: true, sortProperty: 'NAME' },
    { name: 'Club/Team', isSortable: true, sortProperty: 'TEAM' },
    { name: "Points", isSortable: true, sortProperty: 'POINTS' },
    { name: "", isSortable: false },

  ];

  detailHeaders = [
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },

  ];
  constructor(
    protected logger: LoggerService,
    private injector: Injector,
    protected views: ViewDataService,
    public filter_service: FiltersSeriesEliteRankingService
  ) {
    super(injector, filter_service, new EliteRankingIndoorStore(injector));
    this.filter_service.sortLocator.sortingType = 'RANKING' as any;
    this.filter_service.sortLocator.asc = true;
  }

  ngOnInit() {
    this.subscriptions.push(this.getDataStream().subscribe(next => {
    }));
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  getDataStream(): Observable<Array<any>> {
    return combineLatest(
      this.reload.asObservable(),
      this.filter_service.orderValue,
      this.filter_service.categoriesCombo.comboData,
      this.filter_service.yearCombo.comboData,
      this.filter_service.textSearch.data(300),
    ).pipe(
      map(([reload, order, category, season, search]) => {
        const params = {
          Year: season ? season.Year : undefined,
          CatCode: category.Cat,
          fText: search.text,
          SortBy: order.sortingSend,
          Detailed: 1
        };
        return params;
      }),
      mergeMap(params => {
        return this.model.requestData(params, this.request_more_data);
      }),

    );
  }
}
